// oxlint-disable no-explicit-any
import {toaster} from '@cypro/ui/toaster'
import {mutators} from '@cypro/admin-engine/mutators'
import {queries} from '@cypro/admin-engine/queries'
import {MutateRequest} from '@rocicorp/zero'
import {useZero as useZ} from '@rocicorp/zero/react'

export function useZero() {
  const z = useZ()

  async function attemptMutation<T>(
    request: MutateRequest<any>,
    cb?: (result: ReturnType<typeof z.mutate>) => Promise<T>
  ) {
    try {
      const mutateRes = z.mutate(request)
      const serverRes = await mutateRes.server

      if (serverRes.type === 'error') throw serverRes.error

      if (!cb) return

      const cbRes = await cb(mutateRes)
      return cbRes
    } catch (error) {
      console.error(error)

      if (error && typeof error === 'object') {
        if ('type' in error && typeof error.type === 'string' && error.type === 'zero') {
          toaster.error({title: 'Zero error', description: 'An error occurred while communicating with the server.'})
          return
        }
        if ('details' in error && typeof error.details === 'string') {
          toaster.error({title: error.details})
          return
        }

        if ('message' in error && typeof error.message === 'string') {
          toaster.error({title: error.message})
          return
        }
      }

      if (error instanceof Error) {
        toaster.error({title: error.message})
      }
    }
  }

  return {...z, mutators, queries, attemptMutation}
}
